import { Injectable } from '@angular/core';
import ipRegex from 'ip-regex';
import urlRegex from 'url-regex';
import { Logger } from 'projects/common/src/app/classes';
import { IApiConfig } from 'projects/common/src/app/interfaces/communication';
import { ServerConfigService } from 'src/app/services/server-config.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiBaseService extends Logger {
  protected readonly config: IApiConfig = {
    host: '127.0.0.1',
    port: '8080',
    timeout: '30s',
    retry: 0,
  };

  constructor(protected configServer: ServerConfigService) {
    super();
  }

  /**
   * Inicializa servicio con parámetros
   * @param host ip de servidor
   * @param port puerto se apliación de servidor
   * @param timeout tiempo de espera máximo para una solicitud
   * @param retry cantidad de intentos para una solicitud fallida
   */
  public init(host: string, port: string | number, timeout: string = this.config.timeout, retry: number = this.config.retry): void {
    if (typeof host === 'string') {
      if (ipRegex({ exact: true }).test(host)) {
        this.configServer.getCurrent().host = host;
      } else {
        // TODO ERROR: INVALID_PARAMETER_FORMAT_EXPECTED_DEFAULT
        this.error(`Formato de parámetro invalido [%s]. Se utilizará el valor por defecto [%s]`, host, this.configServer.getCurrent().host);
      }
    }
    if (typeof port === 'string' || typeof port === 'number') {
      this.configServer.getCurrent().port = port.toString();
    } else {
      // TODO ERROR: INVALID_PARAMETER_VALUE_DEFAULT
      this.error(`Valor invalido [%s]. Se utilizará el valor por defecto [%s].`, port, this.configServer.getCurrent().port);
    }
    if (typeof timeout === 'string') {
      this.config.timeout = timeout;
    } else {
      // TODO ERROR: INVALID_PARAMETER_VALUE_DEFAULT
      this.error(`Valor invalido [%s]. Se utilizará el valor por defecto [%s].`, timeout, this.config.timeout);
    }
    if (typeof retry === 'number') {
      this.config.retry = retry;
    } else {
      // TODO ERROR: INVALID_PARAMETER_VALUE_DEFAULT
      this.error(`Valor invalido [%s]. Se utilizará el valor por defecto [%s].`, timeout, this.config.timeout);
    }
  }

  /**
   * Retorna un string con la url de conexión remota definida
   */
  protected serverUrl(): string {
    const protocol = environment.useSSL ? 'https' : 'http';
    if (environment.useSSL) {
      return `${protocol}://${this.configServer.getCurrent().host}`;
    }
    return `${protocol}://${this.configServer.getCurrent().host}:${this.configServer.getCurrent().port}`;
  }

  protected isValidUrl(url: string): boolean {
    return urlRegex({ strict: true }).test(url);
  }

  protected buildUrl(endPoint: string): string {
    if (this.isValidUrl(endPoint)) {
      return endPoint;
    }
    return `${this.serverUrl()}${endPoint}`;
  }
}
